import Card11 from "components/Card11/Card11";
import Heading from "components/Heading/Heading";
import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";
import { usePostsQuery } from "framework/rest/post/posts.query";
import { FC } from "react";
import { Route } from "routers/types";

export interface SingleRelatedPostsProps {
    relatedPosts?: PostDataType[];
    moreFromAuthorPosts?: PostDataType[];
}

// DEMO DATA
let demoRelated: PostDataType[] = DEMO_POSTS.filter((_, i) => i >= 10 && i < 14);
// make differnt href demo, for user can click
demoRelated = demoRelated.map((item, index) => ({
    ...item,
    href: (item.href + index) as Route,
}));

let demoMoreFromAuthor: PostDataType[] = DEMO_POSTS.filter((_, i) => i >= 14 && i < 18);
// make differnt href demo, for user can click
demoMoreFromAuthor = demoMoreFromAuthor.map((item, index) => ({
    ...item,
    href: (item.href + index + "-") as Route,
}));

const SingleRelatedPosts: FC<SingleRelatedPostsProps> = ({
    relatedPosts = demoRelated,
    moreFromAuthorPosts = demoMoreFromAuthor,
}) => {
    const { data: posts } = usePostsQuery({
        limit: 4,
    });
    return (
        <div className="relative bg-neutral-100 dark:bg-neutral-800 py-16 lg:py-28 mt-16 lg:mt-28">
            {/* RELATED  */}
            <div className="container">
                <div>
                    <Heading className="mb-10 text-neutral-900 dark:text-neutral-50" desc="">
                        Diğer İçerikler
                    </Heading>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
                        {posts?.posts.data.map((post) => (
                            <Card11 key={post.id} post={post} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SingleRelatedPosts;
